// Url to test enviroment
/* export const TEST = 'https://tmapi.tech/emt/'; //emt */
/* export const APIKEY = 'Fs3rW9btSS8kMUShMfPl757QPOHoB1Ss7mq44kfu'; //emt */

//dev **
export const TEST = 'https://develop.tmapi.tech/telasist';
export const APIKEY = '8FVIQ68PsL6Wb5NO6xMGM6C0Q2hXIlIN5H2q1VtR';

//prod **
// export const TEST = 'https://v4.tmapi.xyz/telasist';
// export const APIKEY = 'kFTYmXWhKP1IBA4GxbJO78AWS9QCRZc59Ik4CkUr';




// WEBPACK FOOTER //
// ./src/pages/constants.ts